import React, { useState } from "react";
import { Attachment as TeamsAttachment, CloseIcon } from "@fluentui/react-northstar";
import { constants } from "shared/constants";
import { ResponsiveDialog } from "ecom-teams-apps-core";
import pl from "shared/messages/pl";
import { mapExtensionToTeamsIcon, calculateFileSize } from "utils/fileUtils";
import { AttachmentDto } from "tasksBoard/service/api/AttachmentDto";
import styles from "./attachment.module.scss";

interface AttachmentProps {
    attachment: AttachmentDto;
    isMobile?: boolean;

    onClick: () => void;
    onRemove: () => Promise<void>;
}

const Attachment: React.FC<AttachmentProps> = (props: AttachmentProps) => {
    const [isRemoveConfirmationDialogVisible, setIsRemoveConfirmationDialogVisible] = useState(false);

    return (
        <>
            <TeamsAttachment
                style={{ maxWidth: "none" }}
                onClick={props.onClick}
                description={`${calculateFileSize(props.attachment.file.size).toFixed(2)}${constants.megabytesAbbr}`}
                key={`attachment_${props.attachment.id}`}
                actionable
                action={{
                    icon: <CloseIcon />,
                    title: pl.taskDetails.attachments.delete,
                    onClick: (e) => {
                        e.stopPropagation();
                        setIsRemoveConfirmationDialogVisible(true);
                    },
                }}
                className={styles.attachment}
                icon={mapExtensionToTeamsIcon(props.attachment.file.extension)}
                header={`${props.attachment.file.file}`}
            />
            <ResponsiveDialog
                cancelButton={pl.common.close}
                confirmButton={pl.common.confirm}
                onCancel={() => {
                    setIsRemoveConfirmationDialogVisible(false);
                }}
                onConfirm={async () => {
                    setIsRemoveConfirmationDialogVisible(false);
                    await props.onRemove();
                }}
                open={isRemoveConfirmationDialogVisible}
                header={pl.taskDetails.attachments.confirmDeletionDialog.header}
                content={pl.taskDetails.attachments.confirmDeletionDialog.content(props.attachment.file.file)}
                isMobile={props.isMobile}
                gap={"gap.small"}
            />
        </>
    );
};

export default Attachment;
